module.exports = __webpack_public_path__ + "img/player-stats-game-wm.5718d46c.png";